module.exports = __webpack_public_path__ + "img/IT0000321863895.9109f535.png";